/**
 * Detecta `<a href="...">` com URL inválida no HTML do e-mail.
 *
 * Espelho da função em server/_core/htmlLinks.ts — manter as duas em
 * sincronia. Sem import cruzado server↔client porque os bundles são
 * separados (server roda em Node, client em browser).
 *
 * Ver server/_core/htmlLinks.ts pro contexto completo do motivo.
 */

const VALID_PROTOCOLS = ["http:", "https:", "mailto:", "tel:"];

export interface InvalidLink {
  href: string;
  reason: string;
}

export function findInvalidLinks(html: string | null | undefined): InvalidLink[] {
  if (!html) return [];

  const invalid: InvalidLink[] = [];
  const linkRegex = /<a\b[^>]*\bhref\s*=\s*(?:"([^"]*)"|'([^']*)')/gi;

  let match: RegExpExecArray | null;
  while ((match = linkRegex.exec(html)) !== null) {
    const href = (match[1] ?? match[2] ?? "").trim();

    if (href === "") {
      invalid.push({ href, reason: "URL vazia" });
      continue;
    }
    if (href === "#") {
      invalid.push({ href, reason: "Link placeholder (#)" });
      continue;
    }
    if (/^[a-z]+:\/?\/?$/i.test(href)) {
      invalid.push({ href, reason: `URL incompleta (${href})` });
      continue;
    }
    if (/^[a-z]+:/i.test(href)) {
      const protocolMatch = href.match(/^([a-z]+:)/i);
      const protocol = protocolMatch ? protocolMatch[1].toLowerCase() : "";
      if (!VALID_PROTOCOLS.includes(protocol)) {
        invalid.push({ href, reason: `Protocolo não permitido (${protocol})` });
        continue;
      }
    }
  }

  return invalid;
}
